import React, { memo } from 'react';
import { useRouter } from 'next/router';
import {
  excludedRegexList,
  getCategoryName,
  includedRegexList,
} from '../../../../utils/getCategory';
import { handleTrack } from '../../../../utils/tracker';
import { If } from '../../../Atoms/Conditionals';
import { setQueryParamToLink } from '../../../Header/utils';
import { ChildProps, TNAV_LINK_STRUCTURE } from '../types';

interface INAV_LINK {
  childEle: ChildProps;
  parentEle?: TNAV_LINK_STRUCTURE;
}

export const NavLink = memo(function NavLink({
  childEle,
  parentEle,
}: INAV_LINK): JSX.Element {
  const router = useRouter();
  const pageName = getCategoryName({
    regexList: [...includedRegexList, ...excludedRegexList],
    url: router.asPath,
    parent: true,
  });
  const refValue = `${pageName}_pages_navbar`;
  const link = setQueryParamToLink(childEle.url, 'utm_ref', refValue);

  return (
    <a
      key={childEle.id}
      href={link}
      target="_blank"
      className={`group text-black  ${
        parentEle?.bgColor ? 'hover:bg-[#E7F1FE]' : 'hover:bg-[#F4F9FF]'
      } w-full px-6 py-2 font-md text-sm flex items-start text-base sm:p-1`}
      role="menuitem"
      tabIndex={-1}
      id={`menu-item-${childEle.title}`}
      rel="noreferrer"
      data-label={`${childEle.id}`}
      onClick={(e) => handleTrack({ label: 'navbar_dropdown', obj: e.target })}
    >
      <If condition={!!childEle.icon}>
        <div className="w-2/12 sm:w-1/12">
          <img
            src={childEle.icon}
            alt=""
            width={38}
            loading="lazy"
            height={38}
            className="sm:w-8 sm:h-8"
          />
        </div>
      </If>

      <div className="w-10/12 pt-2 pl-2 sm:w-11/12">
        <div className="text-s-14 font-semibold text-font-500 sm:font-medium">
          {childEle.title}
        </div>

        <If condition={!!childEle.desc}>
          <p
            className={`hidden text-s-12 text-font-500 mt-2 group-hover:block`}
          >
            {childEle.desc}
          </p>
        </If>
      </div>
    </a>
  );
});
